import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { ConfigProvider } from 'components/ui'
import useDarkMode from 'utils/hooks/useDarkMode'
import { themeConfig } from 'configs/theme.config'

const Theme = props => {

	const theme = useSelector(state => state.theme)
	const [ isDark ] = useDarkMode()

	const currentTheme = {
		mode: isDark ? 'dark' : 'light',
		...themeConfig,
		...theme
	}

	// MUI components don't see the Tailwind `.dark` class — they theme via this
	// palette. Without it every MUI surface (ad-sales tables/dialogs/drawers,
	// dashboard cards) stayed light in dark mode. Light palette matches the
	// existing slate design so light mode is unchanged; dark palette matches the
	// Tailwind dark greys (gray-900/800/700, gray-100/300 text) so MUI and
	// Tailwind surfaces look consistent. No CssBaseline — the Tailwind base layer
	// owns `body`.
	const muiTheme = useMemo(() => createTheme({
		palette: isDark
			? {
				mode: 'dark',
				background: { default: '#111827', paper: '#1f2937' },
				text: { primary: '#f1f5f9', secondary: '#cbd5e1' },
				divider: '#374151',
			}
			: {
				mode: 'light',
				background: { default: '#f3f4f6', paper: '#ffffff' },
				text: { primary: '#0f172a', secondary: '#475569' },
				divider: '#e2e8f0',
			},
	}), [isDark])

	return (
		<ThemeProvider theme={muiTheme}>
			<ConfigProvider value={currentTheme}>
				{props.children}
			</ConfigProvider>
		</ThemeProvider>
	)
}

export default Theme
